$bog_smalljs_structure_row $mol_view
	prefix \
	name \
	pad \
	comment \
	note \
	kind \
	active false
	pickable false
	pick? null
	line_click? null
	attr *
		bog_smalljs_structure_kind <= kind
		bog_smalljs_structure_active <= active
		bog_smalljs_structure_pickable <= pickable
	sub /
		<= Line $mol_view
			event *
				click? <=> line_click?
			sub <= line_content /
				<= Prefix $mol_view
					sub /
						<= prefix
				<= Name $mol_view
					sub /
						<= name
						<= pad
				<= Comment $mol_view
					sub /
						<= comment
				<= Help $mol_pop_over
					Anchor <= Help_icon $mol_icon_help_circle_outline
					bubble_content /
						<= Note $mol_view
							sub /
								<= note
